import { render, staticRenderFns } from "./OrganizationChart.vue?vue&type=template&id=6bb03e29&scoped=true&"
import script from "./OrganizationChart.vue?vue&type=script&lang=ts&"
export * from "./OrganizationChart.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationChart.vue?vue&type=style&index=0&id=6bb03e29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb03e29",
  null
  
)

export default component.exports